<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" :color="localSchedule.enableCustomPopup ? 'primary' : 'grey lighten-2'" icon @click="editValue()">
          <v-icon>mdi-open-in-app</v-icon>
        </v-btn>
      </template>
      <span>Prepare custom popup</span>
    </v-tooltip>
    <v-dialog v-model="scheduleCustomPopupDialog" max-width="500" persistent>
      <v-card>
        <v-card-title>
          {{ $t("admin.activities.edit.customPopup.header") }}
        </v-card-title>
        <v-card-text class="pt-2">
          <v-form
            ref="scheduleCustomPopupForm"
            v-model="valid"
            class="mx-4 my-2"
            @submit.prevent="saveScheduleCustomPopupForm()"
          >
            <v-text-field
              v-model="customPopupTitle"
              :label="$t('admin.activities.edit.customPopup.title')"
              :rules="[$v.required(), $v.maxLength(255)]"
            ></v-text-field>
            <v-textarea
              v-model="customPopupContent"
              :label="$t('admin.activities.edit.customPopup.content')"
              :rules="[$v.required()]"
              autocomplete="off"
              outlined
            ></v-textarea>
            <v-text-field
              v-model="customPopupMainButtonLabel"
              :label="$t('admin.activities.edit.customPopup.mainButtonLabel')"
              :rules="[$v.required(), $v.maxLength(64)]"
            ></v-text-field>
            <v-text-field
              v-model="customPopupSecondaryButtonLabel"
              :label="$t('admin.activities.edit.customPopup.secondaryButtonLabel')"
              :rules="[$v.maxLength(64)]"
            ></v-text-field>
            <div class="d-flex justify-end">
              <v-btn :disabled="!valid" color="primary" elevation="0" fab tile type="submit" x-small>
                <v-icon>mdi-open-in-app</v-icon>
              </v-btn>
              <v-btn class="ml-1" elevation="0" fab tile x-small @click="closeModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ActivitiesEditCustomPopupModal",
  props: {
    schedule: Object,
  },
  data() {
    return {
      scheduleCustomPopupDialog: false,
      scheduleCustomPopupForm: null,
      customPopupTitle: "",
      customPopupContent: "",
      customPopupMainButtonLabel: "",
      customPopupSecondaryButtonLabel: "",
      valid: false,
    };
  },
  methods: {
    saveScheduleCustomPopupForm() {
      this.localSchedule.customPopupTitle = this.customPopupTitle;
      this.localSchedule.customPopupContent = this.customPopupContent;
      this.localSchedule.customPopupMainButtonLabel = this.customPopupMainButtonLabel;
      this.localSchedule.customPopupSecondaryButtonLabel = this.customPopupSecondaryButtonLabel;

      this.localSchedule.enableCustomPopup = true;
      this.scheduleCustomPopupDialog = false;
    },
    editValue() {
      if (this.localSchedule.enableCustomPopup === true) {
        this.localSchedule.enableCustomPopup = false;
      } else {
        this.customPopupTitle = this.localSchedule.customPopupTitle;
        this.customPopupContent = this.localSchedule.customPopupContent;
        this.customPopupMainButtonLabel = this.localSchedule.customPopupMainButtonLabel;
        this.customPopupSecondaryButtonLabel = this.localSchedule.customPopupSecondaryButtonLabel;

        this.scheduleCustomPopupDialog = true;
      }
    },
    closeModal() {
      this.scheduleCustomPopupDialog = false;
    },
  },
  computed: {
    localSchedule: {
      get() {
        return this.schedule;
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
};
</script>

<style scoped></style>
